import * as basket from "../eaiws/basket";
import { Lock } from "../utils/async";
import { BasketItem } from "./BasketItem";
import { ItemUpdateFlags } from "./BaseItem";
export class TextItem extends BasketItem {
    constructor(pManager, pParent, pChildIndex, pEaiwsItem) {
        super(pManager, pParent, pChildIndex, pEaiwsItem);
        this.mLongText = null;
        this.mLongTextLock = new Lock();
    }
    /** Returns the long text for this folder */
    async getLongText() {
        var _a, _b;
        const tLockContext = await this.mLongTextLock.acquireLock();
        try {
            if (this.mLongText != null)
                return (this.mLongText);
            const tOptions = new basket.GetItemPropertiesOptions();
            tOptions.textMode = "Simple";
            const tProps = await this.mManager.session.basket.getItemProperties([this.id], tOptions);
            const tText = (_b = (_a = tProps[0]) === null || _a === void 0 ? void 0 : _a.textItem) === null || _b === void 0 ? void 0 : _b.longDisplayText;
            this.mLongText = tText !== null && tText !== void 0 ? tText : new Array();
            return (this.mLongText);
        }
        finally {
            tLockContext.unlock();
        }
    }
    /**
     * Sets the label (short text) of this text item.
     */
    async setLabel(pLabel) {
        const tText = await BasketItem.BuildDisplayText(this.basket, pLabel);
        const tProps = new basket.ItemProperties();
        tProps.textItem = new basket.TextItemProperties();
        tProps.textItem.displayText = [tText];
        return (this.setItemProperties(tProps, true, false));
    }
    /**
     * Sets the long text of this text item.
     */
    async setLongText(pText) {
        const tText = await BasketItem.BuildDisplayText(this.basket, pText);
        const tProps = new basket.ItemProperties();
        tProps.textItem = new basket.TextItemProperties();
        tProps.textItem.longDisplayText = [tText];
        return (this.setItemProperties(tProps, false, false, ItemUpdateFlags.UserItemDescription));
    }
    //// protected /////////////////////////////////////////////////////////////////////////////////
    performUpdates(pFlags) {
        if ((pFlags & ItemUpdateFlags.UserItemDescription) != 0)
            this.mLongText = null;
        return (super.performUpdates(pFlags));
    }
}
